import { useSelector } from 'react-redux';

import { usePage } from '../contexts/usePageContext';
import { getBaseDomain } from '../redux/pageDomain';
import { RootState } from '../redux/store';
import { StructureType } from '../types/types';

export const useCurrentStructure = (): StructureType[] => {
 const { pageName } = usePage();
 return useSelector((state: RootState): StructureType[] => {
  const pageState = state[getBaseDomain(pageName)];

  return pageState && 'structure' in pageState
   ? (pageState.structure as StructureType[])
   : [];
 });
};

